import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

export const StyledUnavailabilityWrapper = styled.div`
  padding: 5em 1em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  img {
    height: 100px;
  }
  p {
    margin: 1.15em 0 4.3em;
    text-align: center;
    color: ${({ reason }) =>
      reason === 'maintenance' || reason === 'coming-soon'
        ? themeStyles.colors.accentColors.secondary.main
        : themeStyles.colors.white.main};
  }

  ${themeMedia.tablet`
    background: ${themeStyles.colors.darkGreys[5].main};
    img {
      height: 150px;
    }
    p {
      margin: 2.77em;
    }
  `}
`
